import React, { useEffect, useRef, useState } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { GetInTouchForm, AwardsCarousel} from '../components';
// import AwardsCarousel from './AwardsCarousel';

function WhoWeAre() {
    const [iframeLoaded, setIframeLoaded] = useState(false);
    const videoRef = useRef(null);

    const videoId = 'rB95ju_J4NA';
    const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/0.jpg`;
    const iframeSrc = `https://www.youtube.com/embed/${videoId}`;

    useEffect(() => {
        const currentVideoRef = videoRef.current;
    
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIframeLoaded(true);
                        observer.unobserve(currentVideoRef);
                    }
                });
            },
            {
                rootMargin: '100px',
            }
        );
    
        if (currentVideoRef) observer.observe(currentVideoRef);
    
        return () => {
            if (currentVideoRef) observer.unobserve(currentVideoRef);
        };
    }, []);

    return (
        <>
        <section className="who-we-are bg-white">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                <div className="col-span-full lg:col-start-2 lg:col-end-6">
                    <h2 className="text-3xl mb-6 font-semibold">Who we are</h2>
                    <p>Established in 1998, Holborn Assets is a leading, multi-award winning, global financial services company that provides quality financial advice and wealth management solutions to the international expatriate community in Saudi Arabia.</p>
                    <p>Holborn Assets is a British, family-owned & run company and is the first and only Western financial advisory organisation to have been granted a full regulatory licence from KSA's Ministry of Investment. This places Holborn in a unique position to provide an unparalleled and locally regulated service to our esteemed clientele in Saudi Arabia.</p>
                    <p>Our presence in Saudi Arabia is marked by a dedicated local office, forming part of our expansive network of 18 international offices. Our local presence in Saudi ensures that we are attuned to the unique financial needs and cultural nuances of our clients in Saudi Arabia.</p>
                    <p>Behind the scenes our global team of 450+ staff are committed to delivering a superior client experience and market leading products to our 20,000+ clients worldwide.</p>
                    <div className="mt-4 relative">
                    <div className="aspect-w-16 aspect-h-9 mt-8 h-64 rounded-xl overflow-hidden" ref={videoRef}>
                            {!iframeLoaded ? (
                                <button
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setIframeLoaded(true)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') setIframeLoaded(true);
                                    }}
                                    tabIndex={0}
                                >
                                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
                                    <img
                                        src={thumbnailUrl}
                                        alt="Play Video"
                                        style={{ 
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </div>
                                </button>
                            ) : (
                                <iframe
                                    title="Holborn Assets Group"
                                    src={iframeSrc}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen={true}
                                    className="w-full h-full"
                                ></iframe>
                            )}
                        </div>
                    </div>
                </div>
                <div className="col-span-full lg:col-start-7 lg:col-end-12">
                    <h2 className="text-3xl font-semibold">Get in touch</h2>
                    <div>
                        <GetInTouchForm />
                    </div>
                    <div className="grid grid-cols-12">
                        <div className="col-span-12 lg:col-start-2 lg:col-span-10 flex pt-4">
                            <AwardsCarousel />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}

export default WhoWeAre;